import { getCookie } from 'cookies-next/client'

import { SHOP_ENV } from '../tenant'

const PHARMA_CUSTOMER_SUPPORT_WEEKDAYS_WORKING_TIMES = {
  END_HOUR: 18,
  START_HOUR: 8,
}

const PHARMA_CUSTOMER_SUPPORT_SATURDAYS_WORKING_TIMES = {
  END_HOUR: 16,
  END_MINUTES: 30,
  START_HOUR: 8,
  START_MINUTES: 0,
}
const DATE_DAY_FRIDAY = 5

const isWeekdaySupport = (currentHour: number, currentDay: number): boolean => {
  return (
    currentDay >= 1 &&
    currentDay <= DATE_DAY_FRIDAY &&
    currentHour >= PHARMA_CUSTOMER_SUPPORT_WEEKDAYS_WORKING_TIMES.START_HOUR &&
    currentHour < PHARMA_CUSTOMER_SUPPORT_WEEKDAYS_WORKING_TIMES.END_HOUR
  )
}

const isSaturdaySupport = (
  currentHour: number,
  currentMinutes: number,
): boolean => {
  const isAfterStart =
    currentHour > PHARMA_CUSTOMER_SUPPORT_SATURDAYS_WORKING_TIMES.START_HOUR ||
    (currentHour ===
      PHARMA_CUSTOMER_SUPPORT_SATURDAYS_WORKING_TIMES.START_HOUR &&
      currentMinutes >=
        PHARMA_CUSTOMER_SUPPORT_SATURDAYS_WORKING_TIMES.START_MINUTES)

  const isBeforeEnd =
    currentHour < PHARMA_CUSTOMER_SUPPORT_SATURDAYS_WORKING_TIMES.END_HOUR ||
    (currentHour === PHARMA_CUSTOMER_SUPPORT_SATURDAYS_WORKING_TIMES.END_HOUR &&
      currentMinutes <
        PHARMA_CUSTOMER_SUPPORT_SATURDAYS_WORKING_TIMES.END_MINUTES)

  return isAfterStart && isBeforeEnd
}

export const directContactTelephoneDialogIsPharmaCustomerSupportAvailable = (
  env: SHOP_ENV,
): boolean => {
  const now = new Date(Date.now())
  const currentHour = now.getHours()
  const currentMinutes = now.getMinutes()
  const currentDay = now.getDay()

  // Cookie reading for QS testing
  if (env === SHOP_ENV.QS) {
    const cookieValue = getCookie('x-customer-support-available')
    if (cookieValue !== undefined) {
      return cookieValue === 'true'
    }
  }

  if (currentDay === 0) {
    return false
  }

  if (currentDay <= DATE_DAY_FRIDAY) {
    return isWeekdaySupport(currentHour, currentDay)
  }

  return isSaturdaySupport(currentHour, currentMinutes)
}
